/*
  calendar-handler.js — SaGó · el cajón del carrito: fecha de entrega, suplemento
  de sábado, totales, aviso de envío y pedido mínimo.

  Reescrito el 09/09/2026 (V de REVISION-SILVIA-02-09.md). La versión anterior
  —del desarrollador del tema live, 1.405 líneas— vigilaba el cajón con un
  MutationObserver que reaccionaba a sus propios repintados: unas 10 lecturas
  de /cart.js por segundo con la página quieta, el cajón pintado dos veces por
  segundo, un setInterval de 500 ms, un POST /cart/update.js en cada carga de
  página y la lista de líneas reescrita desde el servidor a destiempo. Eso es lo
  que hacía parpadear la foto del producto y saltar en falso el aviso «Solo
  puedes agregar N de este artículo» de Dawn.

  Cómo funciona ahora
  · Estado: snippets/sago-cart-drawer.liquid lleva un JSON del carrito
    (#sago-carrito-json) dentro de <cart-drawer-items>, que Dawn vuelve a
    pintar en cada cambio por cualquiera de sus tres caminos (renderContents,
    updateQuantity y el onCartUpdate del fork). Pintar lee ese JSON y nunca
    pide /cart.js.
  · Pintar (sin red): contadores sin el suplemento, totales, aviso de envío,
    pedido mínimo (también el de /cart) y el bloque de la fecha con su
    calendario. Es idempotente.
  · Sincronizar (con red solo si hace falta): la fecha del carrito tiene que
    ser válida (si no, la primera disponible) y el suplemento tiene que estar
    exactamente cuando la fecha es sábado y hay productos. Cada POST pide las
    secciones del cajón en la misma llamada y las aplica con dos guardas: no
    si Dawn tiene una petición en vuelo, y no si el usuario va por delante.
  · Disparadores: la carga de página, cada repintado del cajón por Dawn (un
    observador filtrado a «han cambiado los hijos de #CartDrawer o de
    .drawer__inner», que es donde Dawn sustituye nodos; los repintados propios
    van más adentro y no lo despiertan), el evento
    cart-update de Dawn, la apertura del cajón y el cambio de fecha.

  Reservas, tarjeta regalo y envío por peso (29/10/2026, campaña de Navidad)
  · Reservas (Carrito 6): cada línea del JSON lleva «reserva», el día desde el
    que se entrega ese producto (snippets/sago-reserva.liquid; vacío si no es
    de reserva). Un pedido tiene UNA fecha: el primer día que se puede elegir
    es el más tardío entre la primera fecha normal y la mayor reserva del
    carrito, y todo el pedido sale ese día. Una reserva cuya fecha ya no es
    futura se ignora aquí otra vez (la de Liquid es la de cuando se pintó la
    página). Si la fecha guardada queda antes, sincronizar la mueve como mueve
    cualquier fecha inválida. La ventana del calendario sigue siendo de 40
    fechas, contadas desde el primer día elegible, y llega al menos hasta el
    5/1/2027 (VENTANA_HASTA).
  · Tarjeta regalo: no se envía (item.gift_card, o requires_shipping == false),
    así que no cuenta para el pedido mínimo, y un carrito sólo con tarjetas no
    lleva fecha de entrega, ni suplemento de sábado, ni envío en los totales.
    Tampoco cuenta para el envío gratis (ver derivar y la barra): Shopify no
    documenta si las tarifas por precio cuentan las tarjetas regalo y los
    hilos de la comunidad dicen que NO. Se resta por prudencia: si el pago sí
    las cuenta, el cliente ve 7,90 € en el cajón y paga 0 (sorpresa buena); si
    no las cuenta y el cajón dijera «gratis», le cobraríamos 7,90 € por
    sorpresa. El pedido de prueba del 30/10 tiene que confirmarlo.
  · Envío estándar o en frío (Carrito 1): apagado de fábrica. Con el ajuste
    «SaGó · Envío» encendido, <cart-drawer> lleva data-sago-envio-estandar
    (céntimos) y data-sago-envio-estandar-peso (gramos); si el carrito, sin
    el suplemento ni las tarjetas, pesa como mucho eso, la fila de envío dice
    «Envío estándar» con ese precio; si pesa más, «Envío en frío» con la
    tarifa de siempre (metacampo shipping_logic). Gratis desde el umbral en
    los dos casos. Apagado no se escribe nada: el cajón es el de siempre.

  Lo que NO se ha tocado a propósito
  · getNextAvailableDates es la de siempre. Compara los festivos con
    cursor.toISOString(), que en España da el día anterior, así que cada
    festivo de la lista bloquea el día SIGUIENTE al que dice. SaGó rellena la
    lista contando con eso (14/08 bloquea el 15, 24/12 el 25, 07/12 el 8). No
    corregirlo sin cambiar la lista con ellos.
  · El suplemento sigue siendo un producto oculto (variante 51402877141259).
    El camino de la tarifa nativa está decidido y en pausa; cuando se retome,
    todo lo del suplemento está junto, en el bloque «Suplemento de sábado».
  · El aviso «solo quedan N unidades» no vuelve: Dawn ya avisa cuando el
    servidor recorta la cantidad (cartStrings.quantityError).
*/

// Flatpickr en español
if (window.flatpickr) {
  flatpickr.l10ns.es = {
    weekdays: {
      shorthand: ["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"],
      longhand: ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]
    },
    months: {
      shorthand: ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],
      longhand: ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"]
    },
    firstDayOfWeek: 1,
    ordinal: () => "º",
    rangeSeparator: " a ",
    weekAbbreviation: "Sem",
    scrollTitle: "Desplaza para aumentar",
    toggleTitle: "Haz clic para alternar",
    time_24hr: true
  };
  flatpickr.localize(flatpickr.l10ns.es);
}

(function () {
  'use strict';

  const SUPLEMENTO_ID = 51402877141259;
  const SUPLEMENTO_FLAG = 'Suplemento sábado añadido';
  const SUPLEMENTO_EUROS = 5;
  const ATRIBUTO_FECHA = 'Delivery Date';
  const SECCIONES = ['cart-drawer', 'cart-icon-bubble'];
  const MAX_PASADAS_CON_RED = 4; // por si algo no se deja corregir, no insistir para siempre
  const VENTANA_DIAS = 40;       // fechas que ofrece el calendario, contadas desde el primer día elegible
  const VENTANA_HASTA = '2027-01-05'; // SaGó: «calendario abierto hasta el 5/1». Si las 40 fechas acaban antes, se sigue hasta aquí

  const estado = {
    carrito: null,        // último carrito conocido (formato de #sago-carrito-json)
    fechaPendiente: '',   // fecha elegida por el cliente que aún no ha llegado al carrito
    reservas: {},         // variant_id → día de reserva ('' si no es de reserva), de lo último que dijo el JSON del cajón
    cola: Promise.resolve(),
    pasadasConRed: 0,
    programado: false,
    calendario: null,     // instancia de flatpickr viva, para destruirla al repintar
    scrollZona: 0,        // scroll de la zona central del cajón, para devolverlo tras cada repintado
    scrollVacio: false,   // ese scroll era del cajón vacío (no se lleva al lleno, ni al revés)
    scrollPropioHasta: 0, // hasta cuándo los eventos de scroll son de devolverScroll, no del cliente
    escCalendario: false, // el Esc que ha cerrado el calendario: su keyup no debe cerrar el cajón
    fechaElegida: ''      // en móvil, el día marcado en el calendario que aún no se ha guardado
  };

  /* ───────────── utilidades de fecha (las de siempre) ───────────── */

  function toLocalISO(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function parseLocalDate(isoStr) {
    const [y, m, d] = isoStr.split('-').map(Number);
    return new Date(y, m - 1, d);
  }

  function getNowInMadrid() {
    try {
      return new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" }));
    } catch (e) {
      console.warn("No se pudo detectar zona horaria Europe/Madrid, usando local");
      return new Date();
    }
  }

  function formatDate(isoDate) {
    let date;
    if (typeof isoDate === 'string') {
      date = parseLocalDate(isoDate);
    } else if (isoDate instanceof Date) {
      date = new Date(isoDate.getFullYear(), isoDate.getMonth(), isoDate.getDate());
    } else {
      return '';
    }
    return date.toLocaleDateString('es-ES', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
  }

  // «jueves 24 de septiembre» y, para el pie compacto del móvil, «jueves 24 sept.».
  // Escrito a mano y no con toLocaleDateString: según el navegador, es-ES pone
  // una coma detrás del día de la semana o abrevia el mes de otra manera.
  const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  const MESES_CORTOS = ['ene.', 'feb.', 'mar.', 'abr.', 'may.', 'jun.', 'jul.', 'ago.', 'sept.', 'oct.', 'nov.', 'dic.'];
  function fechaLarga(iso) {
    const f = parseLocalDate(iso);
    return `${DIAS[f.getDay()]} ${f.getDate()} de ${MESES[f.getMonth()]}`;
  }
  function fechaCorta(iso) {
    const f = parseLocalDate(iso);
    return `${DIAS[f.getDay()]} ${f.getDate()} ${MESES_CORTOS[f.getMonth()]}`;
  }

  // Tal cual estaba. Ver la nota de cabecera sobre los festivos antes de tocarla.
  function getNextAvailableDates(daysNeeded = 40, config) {
    const dates = [];
    const now = getNowInMadrid();

    const [cutHour, cutMin] = config.cutoff_time.split(':').map(n => parseInt(n, 10));
    const cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutHour, cutMin, 0);

    const condition = now < cutoff ? 'before_cutoff' : 'after_cutoff';
    const rule = config.rules.find(r => r.condition === condition);
    const startOffset = (rule && rule.delivery_days) || config.default_delivery_days || 1;

    const noDelivery = (config.no_delivery_days || []).map(d => d.toLowerCase());
    const holidays = config.holidays || [];

    let cursor = new Date();
    cursor.setDate(cursor.getDate() + startOffset);
    cursor.setHours(0, 0, 0, 0);

    while (dates.length < daysNeeded) {
      const iso = cursor.toISOString().slice(0, 10);
      const weekday = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'][cursor.getDay()];
      const isHoliday = holidays.includes(iso);
      const isNoDelivery = noDelivery.includes(weekday);
      if (!isHoliday && !isNoDelivery) {
        dates.push(new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate()));
      }
      cursor.setDate(cursor.getDate() + 1);
    }
    return dates;
  }

  // La reserva que manda en el carrito: la fecha de reserva MÁS TARDÍA de las
  // líneas que se envían, si todavía es futura. Vacío si no hay ninguna. «Futura»
  // se mira aquí otra vez (sago-reserva.liquid la miró al pintar la página, y
  // el cajón puede llevar abierto desde antes de la medianoche).
  function reservaDelCarrito(carrito) {
    if (!carrito) return '';
    const hoy = toLocalISO(getNowInMadrid());
    let mayor = '';
    for (const linea of carrito.items) {
      if (!sePide(linea)) continue;
      if (linea.reserva && linea.reserva > hoy && linea.reserva > mayor) mayor = linea.reserva;
    }
    return mayor;
  }

  const diasDesdeHoy = (iso) => Math.max(0, Math.ceil((parseLocalDate(iso) - new Date()) / 86400000));

  // Las fechas que se pueden elegir. Sin carrito (o sin reservas) son las de
  // siempre: 40 desde la primera normal. Con reservas, se parte de la primera
  // fecha normal que no sea anterior a la reserva, se cuentan 40 desde ahí y,
  // si no llegan al 5/1/2027, se siguen dando hasta ese día.
  function fechasDisponibles(carrito) {
    const config = window.shippingLogic;
    if (!config || !config.rules) return [];
    try {
      const reserva = reservaDelCarrito(carrito === undefined ? estado.carrito : carrito);
      // Un día de reparto por día natural como máximo: pedir tantos como días
      // hay hasta el último que hace falta (+ las 40 y un margen) nunca se queda corto.
      const hasta = reserva > VENTANA_HASTA ? reserva : VENTANA_HASTA;
      const todas = getNextAvailableDates(diasDesdeHoy(hasta) + VENTANA_DIAS + 15, config);
      const elegibles = reserva ? todas.filter(f => toLocalISO(f) >= reserva) : todas;
      return elegibles.filter((f, i) => i < VENTANA_DIAS || toLocalISO(f) <= VENTANA_HASTA);
    } catch (e) { console.warn('SaGó carrito: fechas', e); return []; }
  }

  // La reserva sólo se cuenta si de verdad retrasa la entrega: si es anterior
  // a la primera fecha normal, el cliente no nota nada.
  function reservaQueManda(carrito) {
    const reserva = reservaDelCarrito(carrito);
    if (!reserva) return '';
    const config = window.shippingLogic;
    if (!config || !config.rules) return '';
    try {
      const primera = getNextAvailableDates(1, config)[0];
      return primera && toLocalISO(primera) < reserva ? reserva : '';
    } catch (e) { return ''; }
  }

  const esSabado = (iso) => !!iso && parseLocalDate(iso).getDay() === 6;

  /* ───────────── el carrito: leer y derivar ───────────── */

  function normalizar(cart) {
    // Admite el JSON del cajón y las respuestas de /cart/*.js, que traen más campos.
    if (!cart || !Array.isArray(cart.items)) return null;
    return {
      item_count: Number(cart.item_count) || 0,
      total_price: Number(cart.total_price) || 0,
      attributes: cart.attributes || {},
      items: cart.items.map((it, i) => {
        const variante = Number(it.variant_id);
        // La reserva sólo la trae el JSON del cajón (es un metacampo del
        // producto); las respuestas de /cart/*.js no. Se recuerda por
        // variante para no perderla al fijar una de esas respuestas.
        if (typeof it.reserva === 'string') estado.reservas[variante] = it.reserva;
        return {
          key: it.key,
          index: typeof it.index === 'number' ? it.index : i,
          variant_id: variante,
          quantity: Number(it.quantity) || 0,
          final_line_price: Number(it.final_line_price != null ? it.final_line_price : it.line_price) || 0,
          reserva: typeof it.reserva === 'string' ? it.reserva : (estado.reservas[variante] || ''),
          gift_card: it.gift_card === true,
          requires_shipping: it.requires_shipping !== false,
          grams: Number(it.grams) || 0
        };
      })
    };
  }

  // Qué es cada línea. El suplemento de sábado es un producto oculto que pone
  // este script; una línea «sin envío» es una tarjeta regalo (o cualquier cosa
  // que Shopify no mande: requires_shipping == false); «se pide» es lo que de
  // verdad hay que entregar. Es la regla de sago_hay_envio en
  // snippets/sago-cart-drawer.liquid y la de la cuenta del pedido mínimo en
  // sections/sago-main-cart-footer.liquid.
  const esSuplemento = (i) => i.variant_id === SUPLEMENTO_ID;
  const sinEnvio = (i) => i.gift_card === true || i.requires_shipping === false;
  const sePide = (i) => !esSuplemento(i) && !sinEnvio(i);

  function leerCarrito() {
    const nodo = document.querySelector('#sago-carrito-json');
    if (nodo) {
      try {
        const c = normalizar(JSON.parse(nodo.textContent));
        if (c) estado.carrito = c;
      } catch (e) { console.warn('SaGó carrito: JSON del cajón ilegible', e); }
    } else if (document.querySelector('cart-drawer') && !document.querySelector('cart-drawer cart-drawer-items')) {
      // El snippet no pinta <cart-drawer-items> (ni el JSON) cuando el carrito
      // está vacío: eso es la verdad, no lo último que supimos.
      estado.carrito = { item_count: 0, total_price: 0, attributes: (estado.carrito && estado.carrito.attributes) || {}, items: [] };
    }
    return estado.carrito;
  }

  // Guarda un carrito conocido como verdad actual, también en el nodo del cajón,
  // para que pintar y sincronizar lean siempre lo mismo (en /cart Dawn no repinta
  // el cajón, así que el nodo se quedaría viejo).
  function fijarCarrito(carrito) {
    if (!carrito) return;
    estado.carrito = carrito;
    const nodo = document.querySelector('#sago-carrito-json');
    if (nodo) nodo.textContent = JSON.stringify(carrito);
  }

  const lineasReales = (c) => c.items.filter(i => !esSuplemento(i)).map(i => `${i.key}:${i.quantity}`).sort().join('|');
  const mismasLineasReales = (a, b) => !!a && !!b && lineasReales(a) === lineasReales(b);

  // El ajuste «SaGó · Envío» (envío estándar o en frío según el peso), apagado
  // de fábrica: sin los data-sago-envio-estandar* en <cart-drawer> es null y
  // nada de lo de abajo cambia.
  function envioEstandar() {
    const nodo = document.querySelector('cart-drawer[data-sago-envio-estandar]');
    if (!nodo) return null;
    const cts = Number(nodo.dataset.sagoEnvioEstandar);
    // 0 es un precio mal escrito en el ajuste («5,90 €» no es un número para
    // Liquid): mejor el envío de siempre que un «Envío estándar: Gratis».
    if (!isFinite(cts) || cts <= 0) return null;
    return { precio: cts / 100, pesoMax: Math.max(0, Number(nodo.dataset.sagoEnvioEstandarPeso) || 0) };
  }

  function derivar(carrito, fecha) {
    const reales = carrito.items.filter(i => !esSuplemento(i));
    const suplementos = carrito.items.filter(esSuplemento);
    // Lo que de verdad se entrega: sin el suplemento y sin las tarjetas regalo.
    const enviadas = reales.filter(sePide);
    const hayEnvio = enviadas.length > 0;
    const unidades = reales.reduce((s, i) => s + i.quantity, 0);
    const subtotal = reales.reduce((s, i) => s + i.final_line_price, 0) / 100;

    // La tarifa del checkout decide el envío gratis sobre el total del carrito:
    // con los descuentos de carrito y CON la línea del suplemento de sábado (es
    // un producto). Se evalúa la regla sobre eso, no sobre el «Subtotal» que se
    // enseña, o el cajón cobraría 7,90 € que el checkout no cobra (96 € + sábado
    // = 101 en el checkout). El suplemento se cuenta por la fecha y no por la
    // línea, igual que el +5 de abajo, para que no cambie al llegar el POST.
    // Es la misma cifra que usa la barra (snippets/sago-envio-barra.liquid).
    // K1 de REVISION-SILVIA-13-09.md.
    //
    // Las tarjetas regalo NO cuentan para esta cifra (29/10). Shopify no dice en
    // su documentación si las tarifas por precio las cuentan; en
    // https://community.shopify.com/t/gift-cards-dont-count-towards-free-shipping/277005
    // los comercios cuentan que no. Se restan por prudencia: si el pago sí las
    // cuenta, el cliente ve 7,90 € en el cajón y luego paga 0 (sorpresa buena);
    // si no las cuenta y el cajón dijera «gratis», se le cobrarían 7,90 € por
    // sorpresa. El pedido de prueba (tarjeta de 100 € + comida de menos de
    // 100 €) tiene que confirmarlo; si el pago las cuenta, quitar `tarjetasEuros`
    // de aquí y de snippets/sago-envio-barra.liquid. El total que se cobra sigue
    // llevando la tarjeta: sólo cambia el envío.
    const lineasSuplemento = suplementos.reduce((s, i) => s + i.final_line_price, 0) / 100;
    const tarjetasEuros = reales.filter(sinEnvio).reduce((s, i) => s + i.final_line_price, 0) / 100;
    const totalCarrito = carrito.total_price != null ? carrito.total_price / 100 : subtotal + lineasSuplemento;
    // Redondeada al céntimo: restar euros con decimales deja 99,99000000000001,
    // que no cae en ninguna regla (0–99,99 y desde 100) y daba «Gratis».
    const baseTarifa = Math.round((totalCarrito - tarjetasEuros - lineasSuplemento + (esSabado(fecha) ? SUPLEMENTO_EUROS : 0)) * 100) / 100;

    const reglas = (window.shippingLogic && window.shippingLogic.shipping_cost && window.shippingLogic.shipping_cost.rules) || [];
    let envio = 0;
    // Nada que enviar (sólo tarjetas regalo): ni envío ni suplemento.
    for (const regla of hayEnvio ? reglas : []) {
      const min = regla.min_order != null ? regla.min_order : 0;
      const max = regla.max_order != null ? regla.max_order : Infinity;
      if (baseTarifa >= min && baseTarifa <= max) { envio = regla.cost; break; }
    }
    // Envío estándar o en frío (Carrito 1). Con el ajuste apagado la etiqueta es
    // la de siempre y la tarifa no se toca. Encendido: hasta el peso de SaGó es
    // estándar, con su precio si la tarifa de arriba cobraba algo (gratis sigue
    // siendo gratis); más pesado, la tarifa de siempre, ahora llamada «en frío».
    let etiquetaEnvio = 'Envío refrigerado';
    const estandar = hayEnvio ? envioEstandar() : null;
    if (estandar) {
      const gramos = enviadas.reduce((s, i) => s + i.grams * i.quantity, 0);
      if (gramos <= estandar.pesoMax) {
        etiquetaEnvio = 'Envío estándar';
        if (envio > 0) envio = estandar.precio;
      } else {
        etiquetaEnvio = 'Envío en frío';
      }
    }
    if (hayEnvio && esSabado(fecha)) envio += SUPLEMENTO_EUROS; // lo que va a pagar: el suplemento sigue a la fecha
    envio = parseFloat(envio.toFixed(2));

    // El total es lo que cobra el checkout: el total del carrito (con los
    // descuentos de carrito, que la suma de líneas no lleva) sin la línea del
    // suplemento, más el envío, que ya lleva el suplemento si es sábado.
    const total = parseFloat((totalCarrito - lineasSuplemento + envio).toFixed(2));

    // Lo que cuenta para el pedido mínimo (Carrito 5, SaGó, 09/10): los
    // productos después de TODOS los descuentos, de línea y de pedido, y sin el
    // envío. Es total_price, que lleva los descuentos y no el envío, quitando
    // lo que no es comida:
    //  · la línea del suplemento de sábado: es un cargo por el día de entrega,
    //    como el envío. Se quita su PARTE del total y no sus 5 € enteros porque
    //    un descuento de pedido también se reparte sobre esa línea: con un −15 %,
    //    restar 5 € dejaba la cifra 0,75 € por debajo de lo que es y la hacía
    //    saltar al entrar el suplemento (medido con SAGOGRACIAS15: 29,40 € de
    //    productos dan 24,99 con y sin sábado).
    //  · las tarjetas regalo (29/10, SaGó: no cuentan; 60 € de tarjeta y 10 € de
    //    comida no llegan a 25). Se quitan ENTERAS: las tarjetas regalo nativas
    //    de Shopify no admiten descuentos, así que no llevan parte de un
    //    descuento de pedido (no medido con un código de descuento).
    // Es decir: (total − tarjetas) × comida / (comida + suplemento). En céntimos,
    // redondeando hacia abajo como Liquid: sections/sago-main-cart-footer.liquid
    // hace la misma cuenta para pintar /cart antes de que llegue este script.
    // Un carrito sin nada que enviar (sólo tarjetas) no tiene mínimo.
    const centimosTarjetas = reales.filter(sinEnvio).reduce((s, i) => s + i.final_line_price, 0);
    const centimosComida = enviadas.reduce((s, i) => s + i.final_line_price, 0);
    const centimosSuplemento = suplementos.reduce((s, i) => s + i.final_line_price, 0);
    const centimosDescontables = centimosComida + centimosSuplemento;
    const baseMinimo = centimosDescontables > 0 ? Math.floor((carrito.total_price - centimosTarjetas) * centimosComida / centimosDescontables) : 0;

    return { reales, suplementos, enviadas, hayEnvio, unidades, subtotal, envio, etiquetaEnvio, total, reglas, baseMinimo, reserva: reservaQueManda(carrito) };
  }

  // La fecha que debe tener el carrito: la elegida y aún no guardada, la guardada
  // si sigue siendo válida, o la primera disponible. «Válida» ya cuenta las
  // reservas: con croquetas de reserva en el carrito, una fecha guardada de
  // noviembre deja de serlo y pasa a la primera desde la reserva.
  function fechaObjetivo(carrito) {
    const validas = fechasDisponibles(carrito || null).map(toLocalISO);
    if (!validas.length) return '';
    const guardada = carrito && carrito.attributes ? carrito.attributes[ATRIBUTO_FECHA] : '';
    if (estado.fechaPendiente) {
      if (guardada === estado.fechaPendiente || !validas.includes(estado.fechaPendiente)) estado.fechaPendiente = '';
      else return estado.fechaPendiente;
    }
    if (guardada && validas.includes(guardada)) return guardada;
    return validas[0];
  }

  /* ───────────── pintar (sin red, idempotente) ───────────── */

  // Las cifras van en TT Hoves Pro Mono, que da a la coma la celda entera de
  // una cifra: se envuelve para recortarla (como en sago-price.liquid).
  const cifra = (n) => `${n.toFixed(2).replace('.', '<span class="sago-coma">,</span>')}&nbsp;€`;
  const euros = (n) => n.toFixed(2).replace('.', ',') + ' €';

  function pintarContadores(d) {
    document.querySelectorAll('.cart-count-bubble').forEach(burbuja => {
      const num = burbuja.querySelector('span[aria-hidden="true"]');
      if (num && num.textContent.trim() !== String(d.unidades)) num.textContent = d.unidades;
      const oculto = burbuja.querySelector('.visually-hidden');
      if (oculto) oculto.textContent = `${d.unidades} artículo${d.unidades === 1 ? '' : 's'}`;
      burbuja.classList.toggle('hidden', d.unidades === 0);
    });
    // «2 artículos» junto a «Tu carrito» (snippets/sago-cajon-cabecera.liquid).
    // El onCartUpdate del fork no repinta la cabecera: se corrige aquí.
    const cuenta = document.querySelector('cart-drawer [data-sago-cuenta]');
    const texto = d.unidades === 0 ? 'vacío' : `${d.unidades} artículo${d.unidades === 1 ? '' : 's'}`;
    if (cuenta && cuenta.textContent.trim() !== texto) cuenta.textContent = texto;
  }

  // Tres renglones en escritorio y, en móvil, una sola línea («Total · envío
  // 7,90 € incl.»): se pintan los dos y el CSS enseña uno u otro. Con el envío
  // conseguido dice «Gratis», no «0,00 €». La nota del sábado va en la fila de
  // entrega, que es donde se elige el día. Un carrito sin nada que enviar
  // (sólo tarjetas regalo) no lleva fila de envío: Subtotal y Total.
  function pintarTotales(d) {
    const bloque = document.getElementById('cart-totals');
    if (!bloque) return;
    if (!d.reales.length) { bloque.innerHTML = ''; return; }

    const envio = d.envio === 0 ? 'Gratis' : cifra(d.envio);
    const envioCompacto = d.envio === 0 ? 'envío gratis' : `envío ${euros(d.envio).replace(' ', '&nbsp;')} incl.`;
    const filaEnvio = d.hayEnvio ? `
        <div class="sago-totales__fila"><dt>${d.etiquetaEnvio}</dt> <dd>${envio}</dd></div>` : '';
    const html = `
      <dl class="sago-totales">
        <div class="sago-totales__fila"><dt>Subtotal</dt> <dd>${cifra(d.subtotal)}</dd></div>${filaEnvio}
        <div class="sago-totales__fila sago-totales__fila--total"><dt>Total</dt> <dd>${cifra(d.total)}</dd></div>
      </dl>
      <p class="sago-totales__compacto">
        <span><strong>Total</strong>${d.hayEnvio ? ` · ${envioCompacto}` : ''}</span>
        <span class="sago-totales__cifra">${cifra(d.total)}</span>
      </p>`;
    if (bloque.dataset.pintado !== html) {
      bloque.innerHTML = html;
      bloque.dataset.pintado = html;
    }
  }

  // El mínimo lo pone SaGó en el editor (Configuración del tema › «SaGó ·
  // carrito») y llega en céntimos en data-sago-pedido-minimo, en <cart-drawer>
  // y en el pie de /cart. Vacío o 0: sin mínimo.
  function pedidoMinimo() {
    const nodo = document.querySelector('[data-sago-pedido-minimo]');
    return nodo ? Math.max(0, Math.round(Number(nodo.dataset.sagoPedidoMinimo)) || 0) : 0;
  }

  // Igual que Liquid: el mínimo sin ,00 si es redondo («25 €», como el «desde
  // 100 €» de la barra) y lo que falta siempre con céntimos («te faltan 0,01 €»,
  // como su «te faltan X €»).
  const importeRedondo = (c) => (c % 100 ? (c / 100).toFixed(2).replace('.', ',') : String(c / 100)) + '&nbsp;€';
  const importe = (c) => (c / 100).toFixed(2).replace('.', ',') + '&nbsp;€';

  // El mismo aviso y el mismo bloqueo en el cajón y en /cart (el pie es
  // sections/sago-main-cart-footer.liquid, que pinta el primer estado; Dawn no
  // lo repinta al cambiar cantidades y aquí se pone al día con el carrito que
  // trae su evento cartUpdate). En /cart se bloquea «Pagar pedido» y se
  // ESCONDEN los botones de pago rápido (Shop Pay, Apple Pay, Google Pay), que
  // no pasan por este botón y se saltaban el mínimo (Checkout 7; los esconde y
  // los vuelve a enseñar esto, sin recargar, al cambiar cantidades). Esconder
  // no es quitar: el bloque sigue en el HTML. Sin nada que enviar (sólo
  // tarjetas regalo) no hay pedido mínimo.
  function pintarPedidoMinimo(d) {
    const minimo = pedidoMinimo();
    const vacio = !d.reales.length;
    const falta = vacio || !d.hayEnvio ? 0 : minimo - d.baseMinimo;
    const corto = falta > 0;
    document.querySelectorAll('#main-cart-footer .additional-checkout-buttons').forEach(rapido => {
      if (rapido.hidden !== corto) rapido.hidden = corto;
    });
    const texto = corto ? `El pedido mínimo es de ${importeRedondo(minimo)}: te faltan <strong>${importe(falta)}</strong>` : '';
    [['CartDrawer-Checkout', 'pedido-minimo-40'], ['checkout', 'sago-minimo-pagina']].forEach(([idBoton, idAviso]) => {
      const boton = document.getElementById(idBoton);
      const aviso = document.getElementById(idAviso);
      if (!boton) return;
      boton.disabled = vacio || corto;
      boton.style.opacity = corto ? '0.5' : '';
      if (aviso) {
        aviso.style.display = corto ? 'block' : 'none';
        if (corto && aviso.dataset.pintado !== texto) { aviso.innerHTML = texto; aviso.dataset.pintado = texto; }
      }
      // Un aria-describedby a un párrafo oculto se lee igual: el lector decía
      // «el pedido mínimo es…» en «Pagar pedido» aunque se pasara del mínimo.
      if (corto && aviso) boton.setAttribute('aria-describedby', idAviso);
      else boton.removeAttribute('aria-describedby');
    });
  }

  const ICONO_CALENDARIO = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="3.5rem" height="3.5rem" zoomAndPan="magnify" viewBox="0 0 150 149.999998" preserveAspectRatio="xMidYMid meet" version="1.2"><defs><clipPath id="940b2f18a9"><path d="M 8.917969 5.441406 L 140.917969 5.441406 L 140.917969 144.191406 L 8.917969 144.191406 Z M 8.917969 5.441406 "/></clipPath></defs><g id="8fb64f1854"><g clip-rule="nonzero" clip-path="url(#940b2f18a9)"><path style=" stroke:none;fill-rule:nonzero;fill:#222222;fill-opacity:1;" d="M 137.253906 133.105469 C 137.253906 137.328125 133.816406 140.765625 129.59375 140.765625 L 20.054688 140.765625 C 15.828125 140.765625 12.394531 137.328125 12.394531 133.105469 L 12.394531 58.636719 L 137.253906 58.636719 Z M 12.394531 33.203125 C 12.394531 28.976562 15.828125 25.542969 20.054688 25.542969 L 36.792969 25.542969 L 36.792969 39.070312 C 36.792969 43.246094 40.1875 46.640625 44.363281 46.640625 C 48.535156 46.640625 51.929688 43.246094 51.929688 39.070312 L 51.929688 25.542969 L 97.714844 25.542969 L 97.714844 39.070312 C 97.714844 43.246094 101.113281 46.640625 105.285156 46.640625 C 109.460938 46.640625 112.855469 43.246094 112.855469 39.070312 L 112.855469 25.542969 L 129.59375 25.542969 C 133.816406 25.542969 137.253906 28.976562 137.253906 33.203125 L 137.253906 55.210938 L 12.394531 55.210938 Z M 40.214844 13.015625 C 40.214844 10.730469 42.074219 8.867188 44.363281 8.867188 C 46.648438 8.867188 48.507812 10.730469 48.507812 13.015625 L 48.507812 39.070312 C 48.507812 41.355469 46.648438 43.214844 44.363281 43.214844 C 42.074219 43.214844 40.214844 41.355469 40.214844 39.070312 Z M 101.140625 13.015625 C 101.140625 10.730469 103 8.867188 105.285156 8.867188 C 107.570312 8.867188 109.429688 10.730469 109.429688 13.015625 L 109.429688 39.070312 C 109.429688 41.355469 107.570312 43.214844 105.285156 43.214844 C 103 43.214844 101.140625 41.355469 101.140625 39.070312 Z M 129.59375 22.117188 L 112.855469 22.117188 L 112.855469 13.015625 C 112.855469 8.839844 109.460938 5.445312 105.285156 5.445312 C 101.113281 5.445312 97.714844 8.839844 97.714844 13.015625 L 97.714844 22.117188 L 51.929688 22.117188 L 51.929688 13.015625 C 51.929688 8.839844 48.535156 5.445312 44.363281 5.445312 C 40.1875 5.445312 36.792969 8.839844 36.792969 13.015625 L 36.792969 22.117188 L 20.054688 22.117188 C 13.941406 22.117188 8.96875 27.089844 8.96875 33.203125 L 8.96875 133.105469 C 8.96875 139.21875 13.941406 144.191406 20.054688 144.191406 L 129.59375 144.191406 C 135.707031 144.191406 140.679688 139.21875 140.679688 133.105469 L 140.679688 33.203125 C 140.679688 27.089844 135.707031 22.117188 129.59375 22.117188 "/></g><path style=" stroke:none;fill-rule:nonzero;fill:#222222;fill-opacity:1;" d="M 33.1875 78.554688 L 48.507812 78.554688 L 48.507812 91.921875 L 33.1875 91.921875 Z M 31.472656 95.347656 L 50.21875 95.347656 C 51.164062 95.347656 51.929688 94.582031 51.929688 93.632812 L 51.929688 76.84375 C 51.929688 75.894531 51.164062 75.128906 50.21875 75.128906 L 31.472656 75.128906 C 30.527344 75.128906 29.761719 75.894531 29.761719 76.84375 L 29.761719 93.632812 C 29.761719 94.582031 30.527344 95.347656 31.472656 95.347656 "/><path style=" stroke:none;fill-rule:nonzero;fill:#222222;fill-opacity:1;" d="M 67.164062 78.554688 L 82.484375 78.554688 L 82.484375 91.921875 L 67.164062 91.921875 Z M 65.449219 95.347656 L 84.195312 95.347656 C 85.140625 95.347656 85.910156 94.582031 85.910156 93.632812 L 85.910156 76.84375 C 85.910156 75.894531 85.140625 75.128906 84.195312 75.128906 L 65.449219 75.128906 C 64.503906 75.128906 63.738281 75.894531 63.738281 76.84375 L 63.738281 93.632812 C 63.738281 94.582031 64.503906 95.347656 65.449219 95.347656 "/><path style=" stroke:none;fill-rule:nonzero;fill:#222222;fill-opacity:1;" d="M 101.140625 78.554688 L 116.460938 78.554688 L 116.460938 91.921875 L 101.140625 91.921875 Z M 99.425781 95.347656 L 118.171875 95.347656 C 119.117188 95.347656 119.886719 94.582031 119.886719 93.632812 L 119.886719 76.84375 C 119.886719 75.894531 119.117188 75.128906 118.171875 75.128906 L 99.425781 75.128906 C 98.484375 75.128906 97.714844 75.894531 97.714844 76.84375 L 97.714844 93.632812 C 97.714844 94.582031 98.484375 95.347656 99.425781 95.347656 "/><path style=" stroke:none;fill-rule:nonzero;fill:#222222;fill-opacity:1;" d="M 33.1875 108.039062 L 48.507812 108.039062 L 48.507812 121.40625 L 33.1875 121.40625 Z M 31.472656 124.832031 L 50.21875 124.832031 C 51.164062 124.832031 51.929688 124.066406 51.929688 123.121094 L 51.929688 106.328125 C 51.929688 105.382812 51.164062 104.613281 50.21875 104.613281 L 31.472656 104.613281 C 30.527344 104.613281 29.761719 105.382812 29.761719 106.328125 L 29.761719 123.121094 C 29.761719 124.066406 30.527344 124.832031 31.472656 124.832031 "/><path style=" stroke:none;fill-rule:nonzero;fill:#222222;fill-opacity:1;" d="M 67.164062 108.039062 L 82.484375 108.039062 L 82.484375 121.40625 L 67.164062 121.40625 Z M 65.449219 124.832031 L 84.195312 124.832031 C 85.140625 124.832031 85.910156 124.066406 85.910156 123.121094 L 85.910156 106.328125 C 85.910156 105.382812 85.140625 104.613281 84.195312 104.613281 L 65.449219 104.613281 C 64.503906 104.613281 63.738281 105.382812 63.738281 106.328125 L 63.738281 123.121094 C 63.738281 124.066406 64.503906 124.832031 65.449219 124.832031 "/><path style=" stroke:none;fill-rule:nonzero;fill:#222222;fill-opacity:1;" d="M 101.140625 108.039062 L 116.460938 108.039062 L 116.460938 121.40625 L 101.140625 121.40625 Z M 99.425781 124.832031 L 118.171875 124.832031 C 119.117188 124.832031 119.886719 124.066406 119.886719 123.121094 L 119.886719 106.328125 C 119.886719 105.382812 119.117188 104.613281 118.171875 104.613281 L 99.425781 104.613281 C 98.484375 104.613281 97.714844 105.382812 97.714844 106.328125 L 97.714844 123.121094 C 97.714844 124.066406 98.484375 124.832031 99.425781 124.832031 "/><g style="fill:#fdfcfa;fill-opacity:1;"><g transform="translate(144.956698, 133.505264)"><path style="stroke:none" d="M 0.046875 0 L 0.046875 -0.125 L 0.171875 -0.125 L 0.171875 0 Z M 0.046875 0 "/></g></g><g style="fill:#fdfcfa;fill-opacity:1;"><g transform="translate(145.173699, 133.505264)"><path style="stroke:none" d="M 0.203125 0.015625 C 0.160156 0.015625 0.125 0.0078125 0.09375 0 C 0.0703125 -0.0078125 0.0507812 -0.0195312 0.03125 -0.03125 L 0.046875 -0.125 C 0.0664062 -0.113281 0.0859375 -0.101562 0.109375 -0.09375 C 0.140625 -0.0820312 0.171875 -0.078125 0.203125 -0.078125 C 0.222656 -0.078125 0.238281 -0.0820312 0.25 -0.09375 C 0.269531 -0.101562 0.28125 -0.113281 0.28125 -0.125 C 0.28125 -0.144531 0.273438 -0.160156 0.265625 -0.171875 C 0.253906 -0.179688 0.242188 -0.1875 0.234375 -0.1875 C 0.222656 -0.195312 0.207031 -0.203125 0.1875 -0.203125 C 0.15625 -0.210938 0.128906 -0.222656 0.109375 -0.234375 C 0.0859375 -0.253906 0.0664062 -0.269531 0.046875 -0.28125 C 0.0351562 -0.300781 0.03125 -0.328125 0.03125 -0.359375 C 0.03125 -0.390625 0.0351562 -0.414062 0.046875 -0.4375 C 0.0664062 -0.457031 0.0859375 -0.472656 0.109375 -0.484375 C 0.140625 -0.492188 0.175781 -0.5 0.21875 -0.5 C 0.25 -0.5 0.273438 -0.492188 0.296875 -0.484375 C 0.328125 -0.484375 0.351562 -0.476562 0.375 -0.46875 L 0.359375 -0.375 C 0.335938 -0.382812 0.316406 -0.394531 0.296875 -0.40625 C 0.273438 -0.414062 0.25 -0.421875 0.21875 -0.421875 C 0.195312 -0.421875 0.175781 -0.414062 0.15625 -0.40625 C 0.144531 -0.394531 0.140625 -0.378906 0.140625 -0.359375 C 0.140625 -0.347656 0.148438 -0.335938 0.171875 -0.328125 C 0.191406 -0.316406 0.21875 -0.300781 0.25 -0.28125 C 0.269531 -0.28125 0.285156 -0.273438 0.296875 -0.265625 C 0.316406 -0.253906 0.332031 -0.242188 0.34375 -0.234375 C 0.363281 -0.222656 0.375 -0.207031 0.375 -0.1875 C 0.382812 -0.175781 0.390625 -0.160156 0.390625 -0.140625 C 0.390625 -0.109375 0.382812 -0.0820312 0.375 -0.0625 C 0.363281 -0.0390625 0.34375 -0.0195312 0.3125 0 C 0.28125 0.0078125 0.242188 0.015625 0.203125 0.015625 Z M 0.203125 0.015625 "/></g></g></g></svg>';

  // La fila de entrega del pie: icono, «Entrega jueves 24 de septiembre» y
  // «Modificar». Es condición de la compra y tiene que verse siempre (PDF,
  // pieza 6), por eso va en el pie y no en la zona que se desplaza.
  // La nota de las reservas, bajo la fila: sólo si la reserva es lo que manda en
  // la fecha (reservaQueManda). Va en granate, como la de «Sábado».
  const notaReserva = (d) => d.reserva
    ? `Tu pedido lleva productos con reserva: lo entregamos todo junto a partir del ${fechaLarga(d.reserva)}.`
    : '';

  function pintarFecha(d, fecha) {
    const bloque = document.getElementById('cart-delivery-summary');
    // Sin fila de entrega (carrito vacío, o sólo tarjetas regalo: no hay nada
    // que entregar) no hay «Modificar»: el calendario, que cuelga de
    // #CartDrawer y sobrevive al repintado, se destruye.
    if (!bloque || !d.reales.length || !d.hayEnvio || !fecha) {
      if (estado.calendario) { try { estado.calendario.destroy(); } catch (e) {} estado.calendario = null; }
      if (bloque) { bloque.innerHTML = ''; bloque.hidden = true; delete bloque.dataset.renderedDate; delete bloque.dataset.ventana; delete bloque.dataset.reserva; }
      return;
    }
    bloque.hidden = false;

    // Las fechas que ofrece el calendario cambian con las reservas del carrito
    // (y con la hora, al pasar el corte): si cambian, el calendario se monta
    // de nuevo, no se reutiliza.
    const proximas = fechasDisponibles(estado.carrito);
    const ventana = proximas.length ? `${toLocalISO(proximas[0])}|${toLocalISO(proximas[proximas.length - 1])}` : '';
    const nota = notaReserva(d);

    const input = bloque.querySelector('#cart_delivery_date');
    const montado = !!(input && input._flatpickr) && bloque.dataset.ventana === ventana;
    if (montado && bloque.dataset.renderedDate === fecha && (bloque.dataset.reserva || '') === (d.reserva || '')) return;

    const sabado = esSabado(fecha) ? `<span class="sago-entrega__nota">Sábado: suplemento de ${euros(SUPLEMENTO_EUROS)}</span>` : '';
    const texto = `<strong class="date-strong"><span class="sago-entrega__larga">Entrega ${fechaLarga(fecha)}</span><span class="sago-entrega__corta">Entrega ${fechaCorta(fecha)}</span></strong>${sabado}`;

    if (montado) {
      // Mismo calendario, otra fecha u otra nota: basta con cambiar el texto y el día
      const parrafo = bloque.querySelector('.sago-entrega__texto');
      if (parrafo) parrafo.innerHTML = texto;
      const aviso = bloque.querySelector('.sago-entrega__reserva');
      if (aviso) { aviso.textContent = nota; aviso.hidden = !nota; }
      if (bloque.dataset.renderedDate !== fecha) input._flatpickr.setDate(fecha, false, 'Y-m-d');
      bloque.dataset.renderedDate = fecha;
      bloque.dataset.reserva = d.reserva || '';
      return;
    }

    bloque.innerHTML = `
    <div class="sago-entrega">
      <span class="sago-entrega__icono" aria-hidden="true">${ICONO_CALENDARIO}</span>
      <p class="sago-entrega__texto">${texto}</p>
      <button type="button" class="sago-entrega__modificar" aria-haspopup="dialog">Modificar<span class="visually-hidden"> la fecha de entrega</span></button>
      <input type="hidden" id="cart_delivery_date" name="attributes[Delivery Date]">
    </div>
    <p class="sago-entrega__reserva"${nota ? '' : ' hidden'}>${nota}</p>`;
    bloque.dataset.renderedDate = fecha;
    bloque.dataset.ventana = ventana;
    bloque.dataset.reserva = d.reserva || '';
    montarCalendario(bloque.querySelector('#cart_delivery_date'), bloque.querySelector('.sago-entrega__modificar'), fecha, proximas);
  }

  const esMovil = () => window.matchMedia('(max-width: 749px)').matches;

  // En escritorio, un calendario pequeño junto a «Modificar» y el día se guarda
  // al pulsarlo. En móvil (≤749), a pantalla completa, con días de 44px y el
  // día no se guarda hasta pulsar «Guardar» (PDF, «Móvil»). `disableMobile`:
  // flatpickr cambia en los móviles a la fecha nativa del sistema, que no sabe
  // de festivos ni de los días sin reparto.
  function montarCalendario(input, boton, fecha, proximas) {
    if (!input || !boton || !window.flatpickr) return;
    if (!proximas || !proximas.length) return;

    // El bloque anterior ya no está en el documento, pero su calendario sí (va al body).
    if (estado.calendario) { try { estado.calendario.destroy(); } catch (e) {} estado.calendario = null; }

    const guardar = (instance) => {
      const elegida = estado.fechaElegida;
      estado.fechaElegida = '';
      instance.close();
      if (elegida) cambiarFecha(elegida);
    };

    estado.calendario = flatpickr(input, {
      locale: 'es',
      dateFormat: 'Y-m-d',
      defaultDate: parseLocalDate(fecha),
      allowInput: false,
      clickOpens: false,
      // flatpickr cierra el calendario al elegir un día; a pantalla completa
      // eso se llevaba el día sin guardar. Lo cierra `guardar` (en escritorio,
      // nada más elegir; en móvil, al pulsar «Guardar»).
      closeOnSelect: false,
      disableMobile: true,
      positionElement: boton,
      enable: proximas,
      minDate: proximas[0],
      maxDate: proximas[proximas.length - 1],
      // Dentro de #CartDrawer y no en el <body>: es el contenedor donde Dawn
      // atrapa el foco tras cada cambio de cantidad, y un calendario fuera
      // de él perdía el foco y flatpickr lo cerraba nada más abrirse.
      // #CartDrawer no tiene transform: `fixed` sigue siendo la pantalla.
      // Pero SÓLO mientras está abierto (ver onReady y abrir): cerrado y
      // colgado del cajón, su «Guardar» oculto pasaba a ser el último
      // elemento de la trampa de foco de Dawn, y el Tab desde «Pagar pedido»
      // se salía del cajón.
      appendTo: document.getElementById('CartDrawer') || document.body,

      // La posición la pone esto y no flatpickr: su positionCalendar corre
      // DESPUÉS de onOpen y escribe coordenadas de página (con el scroll)
      // sobre un calendario `fixed`. Con la página bajada, el calendario se
      // iba tantos píxeles por debajo de la pantalla como se hubiera bajado.
      position(instance) {
        const cal = instance.calendarContainer;
        if (cal.classList.contains('sago-calendario--pantalla')) {
          cal.style.top = '';
          cal.style.left = '';
          return;
        }
        cal.style.position = 'fixed';
        cal.style.zIndex = 9999;
        const r = boton.getBoundingClientRect();
        const alto = cal.offsetHeight, ancho = cal.offsetWidth;
        const { innerWidth, innerHeight } = window;
        // Debajo de «Modificar»; si no cabe, encima; y si tampoco, dentro de la pantalla.
        let top = r.bottom + 4;
        if (top + alto > innerHeight - 8) top = r.top - alto - 4;
        top = Math.max(8, Math.min(top, innerHeight - alto - 8));
        const left = Math.max(8, Math.min(r.right - ancho, innerWidth - ancho - 8));
        cal.style.top = `${top}px`;
        cal.style.left = `${left}px`;
      },

      onReady(_, __, instance) {
        const cal = instance.calendarContainer;
        cal.classList.add('sago-calendario');
        cal.setAttribute('role', 'dialog');
        cal.setAttribute('aria-label', 'Elige el día de entrega');
        cal.insertAdjacentHTML('afterbegin', `
          <div class="sago-calendario__cabecera">
            <p class="sago-calendario__titulo">Día de entrega</p>
            <button type="button" class="sago-calendario__cerrar" aria-label="Cerrar sin cambiar el día">×</button>
          </div>`);
        cal.insertAdjacentHTML('beforeend', `
          <div class="sago-calendario__pie">
            <button type="button" class="sago-calendario__guardar">Guardar</button>
          </div>`);
        cal.querySelector('.sago-calendario__cerrar').addEventListener('click', () => instance.close());
        cal.querySelector('.sago-calendario__guardar').addEventListener('click', () => guardar(instance));
        cal.remove();
      },

      onOpen(_, __, instance) {
        const cal = instance.calendarContainer;
        const pantalla = esMovil();
        cal.classList.toggle('sago-calendario--pantalla', pantalla);
        document.documentElement.classList.toggle('sago-calendario-abierto', pantalla);
      },

      onClose(_, __, instance) {
        document.documentElement.classList.remove('sago-calendario-abierto');
        // Cerrado sin guardar: el calendario vuelve al día que tiene el carrito.
        if (estado.fechaElegida) {
          estado.fechaElegida = '';
          const actual = document.getElementById('cart-delivery-summary');
          if (actual && actual.dataset.renderedDate) instance.setDate(actual.dataset.renderedDate, false, 'Y-m-d');
        }
        instance.calendarContainer.remove();
        // El foco vuelve a «Modificar» sólo si el cajón sigue abierto: al
        // cerrar el cajón con el calendario abierto, el foco tiene que volver
        // a donde lo deja Dawn (el icono del carrito, el botón de añadir).
        const drawer = boton.closest('cart-drawer');
        if (boton.isConnected && drawer && drawer.classList.contains('active')) boton.focus({ preventScroll: true });
      },

      onChange(selectedDates, _, instance) {
        if (!selectedDates.length) return;
        const elegida = selectedDates[0];
        const dia = elegida.getDay();
        if (dia === 0 || dia === 1) { alert('No entregamos en domingo ni lunes'); return; }
        estado.fechaElegida = toLocalISO(elegida);
        if (!instance.calendarContainer.classList.contains('sago-calendario--pantalla')) guardar(instance);
      }
    });

    boton.addEventListener('click', () => {
      const instancia = estado.calendario;
      if (!instancia) return;
      const cajon = document.getElementById('CartDrawer') || document.body;
      if (!instancia.calendarContainer.isConnected) cajon.appendChild(instancia.calendarContainer);
      instancia.open();
    });
  }

  function pintarPaginaCarrito(d, fecha) {
    // La fecha elegida, en /cart (sections/sago-main-cart-footer.liquid). Ahí no
    // hay calendario: la fecha se elige en el cajón. El pie llega pintado con
    // la fecha que tenía el carrito al cargar; si el script la mueve (una
    // reserva, una fecha caducada) o la quita (sólo tarjetas regalo), se pone
    // al día aquí, con el mismo formato que Liquid («jueves, 05 de noviembre
    // de 2026»).
    const resumen = document.getElementById('cart-summary-date');
    if (resumen) {
      const visible = d.reales.length > 0 && d.hayEnvio && !!fecha;
      if (resumen.hidden === visible) resumen.hidden = !visible;
      if (visible) {
        const f = parseLocalDate(fecha);
        const texto = `${DIAS[f.getDay()]}, ${String(f.getDate()).padStart(2, '0')} de ${MESES[f.getMonth()]} de ${f.getFullYear()}`;
        const dia = resumen.querySelector('[data-sago-fecha-resumen]');
        if (dia && dia.textContent !== texto) dia.textContent = texto;
        const aviso = resumen.querySelector('[data-sago-reserva-resumen]');
        const nota = notaReserva(d);
        if (aviso) {
          if (aviso.hidden === !!nota) aviso.hidden = !nota;
          if (aviso.textContent !== nota) aviso.textContent = nota;
        }
      }
    }
    // En /cart Dawn pinta todas las líneas, suplemento incluido: se esconde la fila.
    document.querySelectorAll(`#main-cart-items input[data-quantity-variant-id="${SUPLEMENTO_ID}"]`).forEach(input => {
      const fila = input.closest('tr');
      if (fila) fila.classList.add('supplement-hidden');
    });
    // Sin productos de verdad /cart está vacío aunque quede el suplemento, o
    // mientras sincronizar lo quita con su propio POST, que sólo repinta el
    // cajón. Se marca `is-empty` como hace Dawn en updateQuantity, y
    // component-cart.css esconde la tabla y el pie y enseña «Tu carrito está
    // vacío». Sin esto (medido el 13/10, revisión de Carrito 5) se quedaba la
    // cabecera de la tabla sin filas, «Total estimado 5,00 €» y «Pagar pedido»
    // gris sin aviso. Sólo se pone: quitarlo, cuando vuelve a haber productos,
    // es cosa de Dawn, que repinta las líneas.
    if (!d.reales.length) {
      document.querySelectorAll('cart-items, #main-cart-footer').forEach(el => el.classList.add('is-empty'));
    }
  }

  function pintar() {
    const carrito = leerCarrito();
    if (!carrito) return;
    const fecha = carrito.items.some(sePide) ? fechaObjetivo(carrito) : '';
    const d = derivar(carrito, fecha);
    pintarContadores(d);
    pintarTotales(d);
    pintarPedidoMinimo(d);
    pintarFecha(d, fecha);
    pintarPaginaCarrito(d, fecha);
  }

  /* ───────────── red: un POST, con las secciones del cajón ───────────── */

  async function pedir(ruta, cuerpo) {
    const res = await fetch(ruta, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: SECCIONES.join(','), sections_url: window.location.pathname }, cuerpo))
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(`${ruta}: ${res.status} ${json.description || json.message || ''}`);
    // /cart/add.js devuelve la línea añadida, no el carrito: el carrito va en la sección.
    json.carrito = normalizar(json) || carritoDesdeSecciones(json.sections);
    return json;
  }

  function carritoDesdeSecciones(sections) {
    if (!sections || !sections['cart-drawer']) return null;
    const nodo = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html').querySelector('#sago-carrito-json');
    try { return nodo ? normalizar(JSON.parse(nodo.textContent)) : null; } catch (e) { return null; }
  }

  // Por la clave de la línea y no por su número: el suplemento de sábado entra
  // (o sale) por delante y corre los números de todas. Comparando por número,
  // [A×2, B×1] con el suplemento delante se leía como «el cliente ha tocado
  // una cantidad», no se repintaba, y el cajón se quedaba con los números
  // viejos: el «−» de B mandaba la línea de A.
  const cantidadesEnPantalla = (raiz) => {
    const m = new Map();
    raiz.querySelectorAll('#CartDrawer-CartItems input.quantity__input').forEach(i => m.set(i.dataset.quantityLineKey || i.dataset.index, i.value));
    return m;
  };

  // Aplica el HTML fresco del cajón y de la burbuja. Devuelve false si no ha podido.
  function aplicarSecciones(sections, carrito) {
    if (!sections || !sections['cart-drawer']) return false;
    const cajon = document.querySelector('#CartDrawer');
    const interior = cajon && cajon.querySelector('.drawer__inner');
    if (!interior) return false;

    // Guarda 1: Dawn tiene un cambio en vuelo (cart.js pone esta clase mientras espera).
    const lista = document.getElementById('CartDrawer-CartItems');
    if (lista && lista.classList.contains('cart__items--disabled')) return false;

    const nuevo = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const nuevoInterior = nuevo.querySelector('.drawer__inner');
    if (!nuevoInterior) return false;

    // Guarda 2: el cliente acaba de tocar una cantidad que el servidor aún no tiene.
    const ahora = cantidadesEnPantalla(document), fresco = cantidadesEnPantalla(nuevo);
    for (const [indice, valor] of ahora) {
      if (fresco.has(indice) && fresco.get(indice) !== valor) return false;
    }

    interior.innerHTML = nuevoInterior.innerHTML;
    const vacio = !!carrito && carrito.item_count === 0;
    document.querySelectorAll('cart-drawer, cart-drawer-items').forEach(el => el.classList.toggle('is-empty', vacio));

    const burbuja = document.getElementById('cart-icon-bubble');
    if (burbuja && sections['cart-icon-bubble']) {
      const seccion = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (seccion) burbuja.innerHTML = seccion.innerHTML;
    }
    return true;
  }

  /* ───────────── sincronizar: fecha y suplemento de sábado ───────────── */

  // La fecha (con la nota que lee SaGó en el pedido) y el flag del suplemento van
  // juntos en un solo POST cuando cambian los dos.
  async function guardarAtributos(atributos, fecha) {
    const cuerpo = { attributes: atributos };
    // Fecha nueva: su nota. Fecha quitada (sólo tarjetas regalo): fuera también la nota.
    if (ATRIBUTO_FECHA in atributos) cuerpo.note = atributos[ATRIBUTO_FECHA] ? `📅 Fecha de entrega seleccionada: ${formatDate(fecha)}` : '';
    return pedir('/cart/update.js', cuerpo);
  }

  // ── Suplemento de sábado (todo lo que se va cuando pase a tarifa nativa) ──
  // Deja las líneas del suplemento como deben estar: ninguna, o exactamente una
  // con cantidad 1. Devuelve la última respuesta si ha tocado algo, si no null.
  async function ajustarLineasSuplemento(suplementos, debeEstar) {
    let ultimo = null;
    if (!debeEstar) {
      for (const linea of suplementos) ultimo = await pedir('/cart/change.js', { id: linea.key, quantity: 0 });
      return ultimo;
    }
    if (!suplementos.length) return pedir('/cart/add.js', { items: [{ id: SUPLEMENTO_ID, quantity: 1 }] });
    for (const linea of suplementos.slice(1)) ultimo = await pedir('/cart/change.js', { id: linea.key, quantity: 0 });
    if (suplementos[0].quantity !== 1) ultimo = await pedir('/cart/change.js', { id: suplementos[0].key, quantity: 1 });
    return ultimo;
  }
  // ── fin del suplemento ──

  // La verdad del servidor, en una sola lectura: las secciones traen el JSON del cajón.
  async function pedirSecciones() {
    const res = await fetch(`/?sections=${SECCIONES.join(',')}`, { headers: { Accept: 'application/json' } });
    const sections = await res.json();
    return { sections, carrito: carritoDesdeSecciones(sections) };
  }

  async function pasoDeSincronizacion() {
    const carrito = leerCarrito();
    if (!carrito) return;
    const hayEnvio = carrito.items.some(sePide);
    const hayProductos = carrito.items.some(i => !esSuplemento(i));
    const suplementos = carrito.items.filter(esSuplemento);
    let respuesta = null;
    let lineasTocadas = false;

    if (hayEnvio) {
      const fecha = fechaObjetivo(carrito);
      const debeSuplemento = esSabado(fecha);
      const atributos = {};
      if (fecha && carrito.attributes[ATRIBUTO_FECHA] !== fecha) atributos[ATRIBUTO_FECHA] = fecha;
      const flag = debeSuplemento ? 'sí' : '';
      if ((carrito.attributes[SUPLEMENTO_FLAG] || '') !== flag) atributos[SUPLEMENTO_FLAG] = flag;
      if (Object.keys(atributos).length) respuesta = await guardarAtributos(atributos, fecha);
      const r2 = await ajustarLineasSuplemento(suplementos, debeSuplemento);
      if (r2) { respuesta = r2; lineasTocadas = true; }
    } else if (hayProductos) {
      // Sólo tarjetas regalo (nada que enviar): ni fecha de entrega ni suplemento
      // de sábado. Si el carrito traía de antes una fecha o el suplemento, se quitan.
      const atributos = {};
      if (carrito.attributes[ATRIBUTO_FECHA]) atributos[ATRIBUTO_FECHA] = '';
      if (carrito.attributes[SUPLEMENTO_FLAG]) atributos[SUPLEMENTO_FLAG] = '';
      if (Object.keys(atributos).length) respuesta = await guardarAtributos(atributos, '');
      const r2 = await ajustarLineasSuplemento(suplementos, false);
      if (r2) { respuesta = r2; lineasTocadas = true; }
    } else if (suplementos.length) {
      respuesta = await ajustarLineasSuplemento(suplementos, false); // sólo queda el suplemento: fuera
      lineasTocadas = true;
    }

    if (!respuesta) { estado.pasadasConRed = 0; return; }
    estado.pasadasConRed += 1;

    let fresco = respuesta.carrito;
    let sections = respuesta.sections;
    if (!lineasTocadas) {
      // Sólo atributos: nada visible cambia en la parte de Dawn. Los números y el JSON, y ya.
      fijarCarrito(fresco);
      pintar();
      return;
    }
    if (!fresco || !mismasLineasReales(leerCarrito(), fresco)) {
      // Alguien ha cambiado líneas mientras nuestro POST estaba en vuelo: no pisar
      // con una respuesta vieja; pedir la verdad una vez.
      const verdad = await pedirSecciones();
      sections = verdad.sections;
      fresco = verdad.carrito || fresco;
    }
    fijarCarrito(fresco);
    if (!aplicarSecciones(sections, fresco)) pintar();
    await refrescarTablaCart();
    // Si se ha repintado, el observador vuelve a llamar a pintar y a sincronizar,
    // que ya no tendrá nada que hacer (y pondrá pasadasConRed a 0).
  }

  // En /cart la tabla de líneas es de Dawn y nadie la repinta cuando este script
  // mete o quita el suplemento al cargar: sus filas se quedaban con los índices
  // viejos y el primer «+» actuaba sobre la línea de al lado (el suplemento subía
  // a 2 y la pasta no; medido en WebKit y Chrome, 29/10). Se repinta como lo hace
  // Dawn tras un cambio de cantidad: la sección por su id de plantilla y su
  // `.js-contents`. Solo en /cart, solo si hemos tocado líneas, y nunca con un
  // cambio de Dawn en vuelo (ese ya repinta la tabla por su cuenta).
  async function refrescarTablaCart() {
    const lista = document.getElementById('main-cart-items');
    const destino = lista && lista.querySelector('.js-contents');
    if (!destino || !lista.dataset.id || !window.routes || !window.routes.cart_url) return;
    if (lista.classList.contains('cart__items--disabled')) return;
    try {
      const r = await fetch(`${window.routes.cart_url}?section_id=${encodeURIComponent(lista.dataset.id)}`);
      if (!r.ok) return;
      const nuevo = new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('.js-contents');
      if (nuevo && !lista.classList.contains('cart__items--disabled')) destino.innerHTML = nuevo.innerHTML;
    } catch (e) { console.warn('SaGó carrito: tabla de /cart', e); }
  }

  function sincronizar() {
    if (estado.pasadasConRed >= MAX_PASADAS_CON_RED) {
      console.warn('SaGó carrito: el carrito no se deja corregir; dejo de intentarlo hasta el próximo cambio.');
      return estado.cola;
    }
    estado.cola = estado.cola
      .then(pasoDeSincronizacion)
      .catch(e => console.warn('SaGó carrito: sincronizar', e));
    return estado.cola;
  }

  function cambiarFecha(iso) {
    estado.fechaPendiente = iso;
    estado.pasadasConRed = 0;
    pintar();
    sincronizar();
  }

  /* ───────────── disparadores ───────────── */

  // Varios avisos en el mismo tick (cart-update + observador) → una sola pasada.
  function alCambiarElCajon() {
    if (estado.programado) return;
    estado.programado = true;
    queueMicrotask(() => {
      estado.programado = false;
      pintar();
      // Otra vez después de pintar: el pie llega vacío en el HTML de Dawn y
      // lo rellena pintar(); mientras está vacío, la zona central es más alta
      // y su scroll máximo, más bajo, así que el primer intento se quedaba
      // corto (de 377 a 279, medido).
      devolverScroll();
      sincronizar();
    });
  }

  // Lo que desliza en el cajón: la zona central y, en horizontal (alto
  // ≤ 500 px, sago-cajon.css), <cart-drawer-items> entero.
  const DESLIZA = '.sago-cajon__scroll, cart-drawer-items';

  // El scroll de la zona que desliza, devuelto tras un repintado (ver vigilarCajon).
  function devolverScroll() {
    if (!estado.scrollZona) return;
    const zona = [...document.querySelectorAll(`#CartDrawer :is(${DESLIZA})`)]
      .find(z => z.scrollHeight > z.clientHeight && getComputedStyle(z).overflowY !== 'visible');
    if (!zona) return;
    // Del cajón vacío al lleno (o al revés) la lista es otra: se empieza arriba.
    if (!!zona.closest('.drawer__inner-empty') !== estado.scrollVacio) { estado.scrollZona = 0; return; }
    if (zona.scrollTop === estado.scrollZona) return;
    // Recién repintado, el máximo puede ser menor que lo guardado (los totales
    // llegan vacíos) y el navegador lo recorta: el evento de scroll de ese
    // recorte no es del cliente y no debe pisar lo guardado, o la segunda
    // devolución (tras pintar) se quedaba corta. Medido a 844×390: 593 → 524.
    estado.scrollPropioHasta = performance.now() + 400;
    zona.scrollTop = estado.scrollZona;
  }

  function vigilarCajon() {
    const cajon = document.querySelector('#CartDrawer');
    if (!cajon) return;
    // Dawn repinta de tres maneras: #CartDrawer entero (cart-drawer.js), los hijos
    // de .drawer__inner (cart.js) o sustituyendo <cart-drawer-items> y el pie
    // (onCartUpdate del fork). Los repintados propios van dentro de #cart-totals
    // y #cart-delivery-summary y no cumplen ninguna de las tres.
    const esPieza = (n) => n.nodeType === 1 && (n.tagName === 'CART-DRAWER-ITEMS' || n.classList.contains('cart-drawer__footer') || n.classList.contains('drawer__inner'));

    // Cada repintado sustituye la zona que se desplaza por una nueva, con el
    // scroll a 0: al pulsar «+» en la última línea de un carrito largo, la
    // lista saltaba arriba. Se apunta el scroll y se devuelve en cuanto llega
    // el nodo nuevo (el observador corre antes de que se pinte el fotograma).
    cajon.addEventListener('scroll', (e) => {
      if (!e.target.matches || !e.target.matches(DESLIZA)) return;
      if (performance.now() < estado.scrollPropioHasta) return;
      estado.scrollZona = e.target.scrollTop;
      estado.scrollVacio = !!e.target.closest('.drawer__inner-empty');
    }, true);
    // Si el repintado se ha llevado el elemento que tenía el foco (el «Añadir»
    // de una sugerencia, por ejemplo), el foco caía al <body> con el cajón
    // abierto. Se devuelve al cajón, sin mover la pantalla.
    const devolverFoco = () => {
      const drawer = cajon.closest('cart-drawer');
      if (!drawer || !drawer.classList.contains('active')) return;
      if (cajon.contains(document.activeElement)) return;
      const interior = cajon.querySelector('.drawer__inner');
      if (interior) interior.focus({ preventScroll: true });
    };

    // El calendario cuelga de #CartDrawer (ver montarCalendario): montarlo o
    // destruirlo cambia los hijos de #CartDrawer, y eso no es un repintado.
    const esCalendario = (n) => n.nodeType === 1 && n.classList.contains('flatpickr-calendar');
    new MutationObserver(registros => {
      const repintado = registros.some(r => r.type === 'childList'
        && ![...r.addedNodes, ...r.removedNodes].every(esCalendario)
        && (r.target === cajon
          || (r.target.classList && r.target.classList.contains('drawer__inner'))
          || [...r.addedNodes, ...r.removedNodes].some(esPieza)));
      if (repintado) {
        devolverScroll();
        devolverFoco();
        alCambiarElCajon();
      }
    }).observe(cajon, { childList: true, subtree: true });

    const drawer = cajon.closest('cart-drawer');
    if (drawer) {
      let estabaAbierto = drawer.classList.contains('active');
      new MutationObserver(() => {
        const abierto = drawer.classList.contains('active');
        if (abierto && !estabaAbierto) { estado.pasadasConRed = 0; sincronizar(); }
        if (!abierto && estabaAbierto) {
          estado.scrollZona = 0;
          // close() de flatpickr dispara onClose aunque no estuviera abierto.
          if (estado.calendario && estado.calendario.isOpen) estado.calendario.close();
        }
        estabaAbierto = abierto;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

      // Esc con el calendario abierto cierra el calendario, no el cajón. Dawn
      // cierra el cajón en el keyup del Esc (cart-drawer.js): se para en la
      // fase de captura, antes de llegar a él. flatpickr escucha el keydown en
      // el documento, así que el cierre lo hace esto.
      drawer.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !estado.calendario || !estado.calendario.isOpen) return;
        estado.escCalendario = true;
        e.stopPropagation();
        estado.calendario.close();
      }, true);
      drawer.addEventListener('keyup', (e) => {
        if (e.key !== 'Escape' || !estado.escCalendario) return;
        estado.escCalendario = false;
        e.stopPropagation();
      }, true);
    }
  }

  function escucharDawn() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (evento) => {
      estado.pasadasConRed = 0;
      // Al añadir desde una ficha, Dawn pinta el cajón 800 ms después: el
      // observador se encarga entonces. Ahora el JSON del cajón aún es el viejo.
      if (evento && evento.source === 'product-form') return;
      const completo = evento && evento.cartData && Array.isArray(evento.cartData.items) ? normalizar(evento.cartData) : null;
      if (completo) fijarCarrito(completo);
      alCambiarElCajon();
    });
  }

  function iconoMovil() {
    const boton = document.getElementById('cart-icon-bubble-mobile');
    if (!boton) return;
    boton.addEventListener('click', (evt) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return; // sin cajón, que navegue a /cart
      evt.preventDefault();
      drawer.open(boton);
    });
  }

  function arrancar() {
    vigilarCajon();
    escucharDawn();
    iconoMovil();
    pintar();
    // Con carrito, comprobar que la fecha sigue siendo válida y el suplemento cuadra.
    // Con el carrito vacío no se toca nada: antes se creaba un carrito por visita.
    const carrito = estado.carrito;
    if (carrito && carrito.items.length) sincronizar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  // Para mirar desde la consola (y para el test con node): sagoCarrito.estado, .pintar(), .sincronizar(), .derivar(carrito, fecha)
  window.sagoCarrito = { estado, pintar, sincronizar, fechasDisponibles, fechaObjetivo, derivar, normalizar, reservaDelCarrito };
})();
